import React from "react";
import { NewPamphlet } from "./NewPamphlet";

export const LandingPage = () => {
  return <NewPamphlet />;
};
